export const FAQ_URL = 'https://cleverstart.omnidesk.ru/';
export const TELEGRAM_URL = 'https://t.me/cleverstart_support_bot';
